import { useBoostedGifs } from "queries";

interface IUseWatchBoostedGifs {
  rel?: string;
}

export const useWatchBoostedGifs = ({ rel }: IUseWatchBoostedGifs) => {
  const match = rel?.match(/^(niche|tag):([^,]+)/);
  const filter = match ? { [match[1]]: match[2] } : undefined;

  const { data: boostedPostData } = useBoostedGifs(filter);

  return { boostedPostData };
};
